import * as Joi from 'joi';
import { ExamSchoolFormDataSPERS } from '../../../models';
import { getJoiObject } from '../../../utils/JoiUtils';

const examSchoolingSPERS = (isOpsAdmin = false) =>
  Joi.object<ExamSchoolFormDataSPERS>({
    hasStudyingInSingapore: Joi.string().required().messages({
      'any.required': 'Please select your choice',
      'string.base': `Please select your choice`,
    }),
    selectedAdmissionLevel: getJoiObject(
      Joi.string().required().messages({
        'string.base': `Please select You are Now Seeking Admission to`,
      }),
      !isOpsAdmin
    ),
  });

export default examSchoolingSPERS;
